import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from "rxjs";
import {QueryResult} from "@app/shared";


@Injectable()
export class InternalContactsService {
  constructor(private http: HttpClient) {
  }


  getContractSupportTeam(contractId: number): Observable<QueryResult> {
    const url = `/projects/support-team-contract?contractId=${contractId}`;
    return this.http.get<QueryResult>(url);

  }

}
